import { createSlice } from "@reduxjs/toolkit";

export const modalsSlice = createSlice({
  name: "modals",
  initialState: {
    walletDetail: {
      isOpen: false,
      idp: null,
    },
    walletBalances: {
      isOpen: false,
      idp: null,
    },
  },
  reducers: {
    setWalletDetailModal: (state, action) => {
      state.walletDetail = action.payload;
    },
    setWalletBalancesModal: (state, action) => {
      state.walletBalances = action.payload;
    },
  },
});

export const { setWalletDetailModal } = modalsSlice.actions;
export const { setWalletBalancesModal } = modalsSlice.actions;
export default modalsSlice.reducer;

export const selectWalletDetailModal = (state) => state.modals.walletDetail;
export const selectWalletBalancesModal = (state) => state.modals.walletBalances;

